module.exports = __webpack_public_path__ + "pcph/img/may13.61de01ca.png";